const getSendingMessage = state => state.message;


export default {
  getSendingMessage,
};
